import React, { useState } from 'react';
import './ScrollToTop.scss';

const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 100) {
            setVisible(true)
        }
        else if (scrolled <= 100) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (

        <button onClick={scrollToTop} className='scrollToTop' style={{ display: visible ? 'inline' : 'none' }}>
            <span className='labelTop' >Go to Top</span>
            <span className='iconTop' >^</span>
        </button>

    );
}

export default ScrollButton;